export default __webpack_public_path__ + "static/media/sari (8).55e39604.jpeg";